import camelCase from 'lodash/camelCase';

export function camelCaseObject(nonCamelCaseObj: any) {
    const newObj: any = {};
    for (const key of Object.keys(nonCamelCaseObj)) {
        newObj[camelCase(key)] = nonCamelCaseObj[key];
    }
    return newObj;
}
